<template>
    <div v-show="$store.state.user.userToPublic" class="user-switch-wrap">
        <div class="seg seg-dark">
            <button @click="switchToAdmin()" :class="$store.state.user.isAdmin ? 'on' : ''">Admin</button>
            <button @click="switchToPublic()" :class="$store.state.user.isAdmin ? '' : 'on'">Standard</button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';

export default defineComponent({
    name: 'UserSwitch',
    props: [  ],
    components: {
        
    },
    data() {
        return {
            
        }
    },
    methods: {
        async switchToAdmin() {
            axios.get(`${this.$store.state.apiUrl}/api/switchtoadmin`)
                .then(resp => {
                    window.location.reload();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })
        },
        async switchToPublic() {
            axios.get(`${this.$store.state.apiUrl}/api/signinasuser?phone=${encodeURIComponent(this.$store.state.user.userToPublic.Phone)}&ignoreReturnAdminID=t`)
                .then(resp => {
                    window.location.reload();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })
        }
    }
});
</script>